import {
  RaptorPlatformAction,
  RaptorPlatformStore,
  SET_RAPTOR_PLATFORM_ID,
} from '../../types/redux/raptorPlatform/raptorPlatformTypes';

export default function raptorPlatformReducer(
  state: RaptorPlatformStore = {
    raptorPlatformId: undefined,
  },
  action: RaptorPlatformAction,
): RaptorPlatformStore {
  switch (action.type) {
    case SET_RAPTOR_PLATFORM_ID:
      return {
        ...state,
        raptorPlatformId: action.raptorPlatformId,
      };
    default:
      return state;
  }
}
